module.exports = __webpack_public_path__ + "static/media/ic_minus_black.ae7bc791.png";